import React from 'react';
// Mantendo suas imagens originais
import imgPote1 from '../assets/Pote1.jpg'; 
import imgPote2 from '../assets/Pote2.jpg';
import imgPote3 from '../assets/Pote3.jpg';

const Ofertas = () => {
  // --- FUNÇÃO MÁGICA DE COMPRA (POST) ---
  const finalizarCompra = (idProduto, idVariante) => {
    // 1. Cria um formulário invisível
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://www.paws.com.br/comprar/';
    form.style.display = 'none';

    // 2. Adiciona o ID do Produto (Necessário para identificar o item)
    const inputProd = document.createElement('input');
    inputProd.type = 'hidden';
    inputProd.name = 'add_to_cart';
    inputProd.value = idProduto;
    form.appendChild(inputProd);

    // 3. Adiciona o ID da Variante (Necessário para o estoque/preço)
    const inputVar = document.createElement('input');
    inputVar.type = 'hidden';
    inputVar.name = 'variant_id';
    inputVar.value = idVariante;
    form.appendChild(inputVar);

    // 4. Define quantidade como 1
    const inputQtd = document.createElement('input');
    inputQtd.type = 'hidden';
    inputQtd.name = 'quantity';
    inputQtd.value = '1';
    form.appendChild(inputQtd);

    // 5. Envia o formulário
    document.body.appendChild(form);
    form.submit();
  };

  const kits = [
    {
      id: 1,
      titulo: "1 POTE",
      idProduto: "282965735",
      idVariante: "1267039626", 
      price: "R$ 89",
      cents: ",00",
      parcelas: "12x R$ 9,16",
      oldPrice: "R$ 139,00",
      destaque: false,
      freteGratis: false,
      imagem: imgPote1
    },
    {
      id: 2,
      titulo: "2 POTES",
      idProduto: "283205269",
      idVariante: "1267061333",
      price: "R$ 167",
      cents: ",00",
      parcelas: "12x R$ 17,18",
      oldPrice: "R$ 278,00",
      economize: "Economize R$ 111",
      destaque: false, 
      freteGratis: false, 
      imagem: imgPote2
    },
    {
      id: 3,
      titulo: "3 POTES",
      idProduto: "284771079",
      idVariante: "1275049591",
      price: "R$ 209",
      cents: ",00",
      parcelas: "12x R$ 21,50",
      oldPrice: "R$ 417,00",
      economize: "Economize R$ 208",
      destaque: true, 
      freteGratis: true, 
      imagem: imgPote3
    }
  ];

  return (
    <section id="ofertas" style={styles.section}>
      <div className="container" style={styles.container}>
        
        <h2 style={styles.mainTitle}>
          ESCOLHA O SEU KIT PAWS GUMMY ORIGINAL PREMIUM BALANCE
        </h2>
        
        <p style={styles.subTitle}>
          Ofertas exclusivas por tempo limitado.
        </p>

        <div style={styles.grid}>
          {kits.map((kit) => (
            <div 
              key={kit.id} 
              style={{
                ...styles.card,
                transform: kit.destaque ? 'scale(1.05)' : 'scale(1)',
                border: kit.destaque ? '4px solid #DB6533' : '2px solid #eee',
                zIndex: kit.destaque ? 10 : 1,
                boxShadow: kit.destaque ? '0 20px 40px rgba(219, 101, 51, 0.2)' : '0 10px 20px rgba(0,0,0,0.05)'
              }}
              className="oferta-card"
            >
              
              {kit.freteGratis && (
                <div style={styles.badgeFrete}>
                  🚚 FRETE GRÁTIS
                </div>
              )}
              
              <h3 style={styles.kitTitle}>{kit.titulo}</h3>
              
              {kit.subtitulo && (
                <p style={styles.kitSub}>{kit.subtitulo}</p>
              )}

              <div style={styles.imgContainer}>
                 <img src={kit.imagem} alt={kit.titulo} style={{maxWidth: '100%', maxHeight: '100%'}} />
              </div>

              <div style={styles.priceContainer}>
                <p style={styles.oldPrice}>De {kit.oldPrice}</p>
                
                <div style={styles.newPriceWrapper}>
                   <span style={styles.currency}>Por</span>
                   <span style={styles.bigPrice}>{kit.price}</span>
                   <span style={styles.cents}>{kit.cents}</span>
                </div>
                
                <p style={styles.parcelas}>{kit.parcelas}</p>
                
                {kit.economize && (
                    <span style={styles.economizeTag}>{kit.economize}</span>
                )}
              </div>

              {/* --- BOTÃO ATUALIZADO PARA USAR A FUNÇÃO POST --- */}
              <button 
                onClick={() => finalizarCompra(kit.idProduto, kit.idVariante)}
                style={kit.destaque ? styles.btnDestaque : styles.btnNormal}
              >
                COMPRAR AGORA
              </button>

            </div>
          ))}
        </div>
        
        <div style={styles.security}>
            🔒 Compra 100% Segura • Dados Protegidos
        </div>

      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '60px 20px',
    backgroundColor: '#F5F9F6', 
    textAlign: 'center'
  },
  container: {
    maxWidth: '1100px',
    margin: '0 auto'
  },
  mainTitle: {
    color: '#397449', 
    fontSize: '2.2rem',
    marginBottom: '10px',
    textTransform: 'uppercase',
    fontFamily: '"Titan One", sans-serif',
    lineHeight: '1.2'
  },
  subTitle: {
    color: '#666',
    marginBottom: '50px',
    fontFamily: '"Commissioner", sans-serif',
    fontSize: '1.1rem'
  },
  grid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', 
    gap: '25px',
    flexWrap: 'wrap',
    paddingTop: '20px' 
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '30px', 
    padding: '30px 20px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '300px',
    minHeight: '520px', 
    transition: 'all 0.3s ease',
    cursor: 'default'
  },
  badgeFrete: {
    position: 'absolute',
    top: '-15px',
    backgroundColor: '#32CD32', 
    color: '#006400',
    fontWeight: '900',
    padding: '8px 20px',
    borderRadius: '20px',
    fontSize: '0.9rem',
    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
    zIndex: 20
  },
  kitTitle: {
    color: '#5D2E8C', 
    fontSize: '1.8rem',
    fontFamily: '"Titan One", sans-serif',
    margin: '10px 0 5px 0'
  },
  kitSub: {
    color: '#888',
    fontSize: '0.9rem',
    marginBottom: '15px',
    fontWeight: 'bold',
    fontFamily: '"Commissioner", sans-serif'
  },
  imgContainer: {
    height: '160px', 
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px'
  },
  priceContainer: {
    marginBottom: '25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  oldPrice: {
    textDecoration: 'line-through',
    color: '#aaa',
    fontSize: '0.9rem',
    margin: 0
  },
  newPriceWrapper: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    gap: '4px',
    color: '#397449'
  },
  currency: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#555'
  },
  bigPrice: {
    fontSize: '2.8rem', 
    fontFamily: '"Titan One", sans-serif',
    fontWeight: '900',
    color: '#397449'
  },
  cents: {
    fontSize: '1rem',
    fontWeight: 'bold',
    alignSelf: 'flex-start',
    marginTop: '10px'
  },
  parcelas: {
    color: '#DB6533', 
    fontWeight: 'bold',
    fontSize: '1.2rem',
    marginTop: '-5px'
  },
  economizeTag: {
    backgroundColor: '#E7F9EA',
    color: '#397449',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    padding: '4px 10px',
    borderRadius: '10px',
    marginTop: '5px'
  },
  btnNormal: {
    width: '100%',
    padding: '15px',
    borderRadius: '50px',
    border: '2px solid #397449',
    backgroundColor: '#fff',
    color: '#397449',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: 'auto',
    textAlign: 'center',
    textDecoration: 'none',
    fontFamily: '"Commissioner", sans-serif'
  },
  btnDestaque: {
    width: '100%',
    padding: '18px',
    borderRadius: '50px',
    border: 'none',
    backgroundColor: '#DB6533', 
    color: '#fff',
    fontWeight: '900',
    fontSize: '1.2rem',
    cursor: 'pointer',
    boxShadow: '0 10px 20px rgba(219, 101, 51, 0.4)',
    marginTop: 'auto',
    textAlign: 'center',
    textDecoration: 'none',
    fontFamily: '"Commissioner", sans-serif',
    textTransform: 'uppercase'
  },
  security: {
    marginTop: '50px',
    color: '#999',
    fontSize: '0.9rem',
    fontFamily: '"Commissioner", sans-serif'
  }
};

const styleSheet = document.createElement("style");
styleSheet.innerText = `
  @media (max-width: 900px) {
    #ofertas .container > div.oferta-grid { 
       flex-direction: column !important;
    }
    .oferta-card {
       width: 100% !important;
       max-width: 340px !important;
       margin-bottom: 40px;
       transform: scale(1) !important; 
    }
    h2 { fontSize: 1.8rem !important; }
  }
`;
document.head.appendChild(styleSheet);

export default Ofertas;